<div class="pa-chat">
    <div *ngIf="isConnected === false" class="pa-connection-problem">{{'NO_CONNECTION_ERROR' | translate}}</div>

    <div #dialog class="pa-dialog">
        <chat-message-indicator *ngIf="showEndOfHistoryIndicator"
                                [message]="endOfHistoryMessage"
                                class="pa-dialog-message-indicator"></chat-message-indicator>

        <ng-container *ngFor="let messageGroup of dialogViewModel.messageGroups; trackBy:getMessageGroupKey">

            <chat-message-indicator *ngIf="messageGroup.sender === 'divider'"
                                    [message]="'NEW_MESSAGES' | translate"
                                    class="pa-dialog-message-indicator"></chat-message-indicator>

            <div *ngIf="messageGroup.sender !== 'divider'"
                 [class.pa-bot]="messageGroup.sender === 'server'"
                 [class.pa-user]="messageGroup.sender === 'client'">
                <div *ngIf="messageGroup.sender === 'server' && messageGroup.botAvatarImageUrl !== undefined"
                     [style.background-image]="'url(' + messageGroup.botAvatarImageUrl + ')'"
                     class="pa-avatar"></div>
                <div *ngIf="messageGroup.sender === 'server' && messageGroup.botAvatarImageUrl === undefined && botAvatar(messageGroup) === true "
                     [style.background-image]="'url(' + dialogViewModel.messageGroups[dialogViewModel.messageGroups.indexOf(messageGroup)-2].botAvatarImageUrl + ')'"
                     class="pa-avatar"></div>
                <div *ngIf="messageGroup.sender === 'server' && messageGroup.botAvatarImageUrl === undefined && botAvatar(messageGroup) === false"
                     class="pa-avatar"></div>
                <div *ngIf="messageGroup.sender === 'client'" class="pa-avatar"></div>
                <div class="pa-messages">
                    <botato-chat-message
                        *ngFor="let message of messageGroup.messages; trackBy:getMessageKey"
                        [class.pa-message]="(message.type !== 'selectionlist') && (message.type !== 'multiselectionlist')"
                        [class.pa-selection-list]="(message.type === 'selectionlist') || (message.type === 'multiselectionlist')"
                        [message]="message"></botato-chat-message>
                </div>
            </div>

        </ng-container>

        <div *ngIf="dialogViewModel.quickReplies !== undefined" class="pa-quickreplies">
            <button (click)="selectQuickReply(quickReply)" *ngFor="let quickReply of dialogViewModel.quickReplies" [innerHTML]="quickReply.displayText | emoji"
                    [ngClass]="quickReply.cssClasses" class="pa-quickreply"
                    type="button">
            </button>
        </div>

    </div>

    <botato-chat-input [inputComponentFocus]="inputComponentFocus"
                       [options]="inputOptions"
                       [type]="inputType"></botato-chat-input>
</div>
